import { Dropdown } from "antd";

export const RADropdown = ({ items = [], placement = "bottomRight", element, trigger = "click" }) => (
	<Dropdown menu={{ items }} placement={placement} trigger={[trigger]} arrow={{ pointAtCenter: true }}>
		{element}
	</Dropdown>
);
